<template>
  <div class="company-offers-page">
    <div v-if="companyData" class="company-header">
      <h1 class="page-title">
        <LinkEntity
          :payload="companyData"
          :additional_data="{ resource_type: 'Company' }"
        />
        - Company Offers
      </h1>
    </div>
    <CompanyOffers :payload="payload" />
  </div>
</template>

<script>
import CompanyOffers from '@/components/admin/CompanyOffers.vue'
import LinkEntity from '@/components/LinkEntity.vue'

export default {
  name: 'CompanyOffersPage',
  data () {
    return {
      companyData: null,
      isLoadingCompany: false
    }
  },
  computed: {
    payload () {
      return {
        company_id: this.$route.params.company_id || this.$route.query.company_id,
        company_name: this.$route.params.company_name || this.$route.query.company_name
      }
    },
    companyId () {
      return this.$route.params.company_id || this.$route.query.company_id
    }
  },
  watch: {
    companyId: {
      immediate: true,
      handler (newCompanyId) {
        if (newCompanyId) {
          this.fetchCompanyData(newCompanyId)
        }
      }
    }
  },
  methods: {
    async fetchCompanyData (companyId) {
      if (!companyId) return

      this.isLoadingCompany = true
      try {
        const response = await this.$network_utils.getCompany({ id: companyId })
        this.companyData = {
          ...response,
          resource_id: response.id || response.user_id
        }
      } catch (error) {
        console.error('Error fetching company data:', error)
        this.$utils.emit('show_toast', { text: 'Failed to load company information', type: 'error' })
      } finally {
        this.isLoadingCompany = false
      }
    }
  },
  components: {
    CompanyOffers,
    LinkEntity
  }
}
</script>

<style scoped>
.company-offers-page {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.company-header {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  border-left: 4px solid #007bff;
}

.page-title {
  margin: 0;
  font-size: 24px;
  color: #333;
  display: flex;
  align-items: center;
  gap: 10px;
}

.header-section {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.header-section h1 {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 28px;
}

.company-selector {
  margin-bottom: 20px;
}

.company-selector label {
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
  color: #555;
}

.form-select {
  width: 100%;
  max-width: 400px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.company-name {
  font-size: 18px;
  font-weight: bold;
  color: #007bff;
  margin: 10px 0;
}

.status-filter {
  margin-top: 20px;
}

.status-filter label {
  display: block;
  margin-bottom: 10px;
  font-weight: bold;
  color: #555;
}

.status-checkboxes {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-weight: normal !important;
  cursor: pointer;
}

.checkbox-label input[type="checkbox"] {
  margin: 0;
}

.loading-state, .no-selection, .no-data {
  text-align: center;
  padding: 40px;
  color: #666;
  font-size: 16px;
}

.offers-section {
  margin-top: 20px;
}

.offers-table-container {
  overflow-x: auto;
}

.offers-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.offers-table th {
  background: #f8f9fa;
  padding: 12px 8px;
  text-align: right;
  border-bottom: 2px solid #dee2e6;
  font-weight: bold;
  color: #495057;
}

.offers-table td {
  padding: 12px 8px;
  border-bottom: 1px solid #dee2e6;
  vertical-align: top;
}

.offer-row:hover {
  background-color: #f8f9fa;
}

.applicant-cell {
  min-width: 200px;
}

.applicant-info strong {
  display: block;
  margin-bottom: 4px;
  color: #333;
}

.applicant-details {
  font-size: 12px;
  color: #666;
}

.applicant-details span {
  display: block;
}

.position-cell {
  min-width: 200px;
}

.position-info strong {
  display: block;
  margin-bottom: 4px;
  color: #333;
}

.position-description {
  font-size: 12px;
  color: #666;
}

.status-cell {
  min-width: 120px;
}

.status-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  display: inline-block;
  min-width: 80px;
}

.status-pending {
  background: #fff3cd;
  color: #856404;
}

.status-approved {
  background: #d4edda;
  color: #155724;
}

.status-rejected {
  background: #f8d7da;
  color: #721c24;
}

.status-in-progress {
  background: #d1ecf1;
  color: #0c5460;
}

.status-completed {
  background: #d4edda;
  color: #155724;
}

.status-cancelled {
  background: #f8d7da;
  color: #721c24;
}

.status-default {
  background: #e2e3e5;
  color: #383d41;
}

.score-cell {
  min-width: 100px;
}

.score-info strong {
  display: block;
  font-size: 16px;
  color: #333;
}

.score-details {
  font-size: 11px;
  color: #666;
  margin-top: 2px;
}

.distance-cell, .date-cell, .owner-cell {
  min-width: 100px;
  font-size: 13px;
}

.actions-cell {
  min-width: 80px;
}

.btn {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  text-decoration: none;
  display: inline-block;
  text-align: center;
}

.btn-sm {
  padding: 4px 8px;
  font-size: 11px;
}

.btn-info {
  background: #17a2b8;
  color: white;
}

.btn-info:hover {
  background: #138496;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow-y: auto;
}

.modal-header {
  padding: 20px;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
}

.offer-details {
  display: grid;
  gap: 15px;
}

.detail-group {
  display: grid;
  grid-template-columns: 150px 1fr;
  gap: 10px;
  align-items: start;
}

.detail-group label {
  font-weight: bold;
  color: #555;
}

.message-content {
  background: #f8f9fa;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #e9ecef;
  white-space: pre-wrap;
  font-family: monospace;
  font-size: 13px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .company-offers-page {
    padding: 10px;
  }

  .status-checkboxes {
    flex-direction: column;
    gap: 10px;
  }

  .offers-table {
    font-size: 12px;
  }

  .offers-table th,
  .offers-table td {
    padding: 8px 4px;
  }

  .detail-group {
    grid-template-columns: 1fr;
    gap: 5px;
  }

  .modal-content {
    width: 95%;
    margin: 10px;
  }
}
</style>
